import { buildSlots, EVENT_END_MINUTES, EVENT_START_MINUTES } from "../lib/slots";

const backendApi = (suffix) => ({
  availability: `/backend/get_time_availability${suffix}.php`,
  create: `/backend/create_reservation${suffix}.php`,
  reservations: `/backend/get_reservations${suffix}.php`,
  cancel: `/backend/cancel_reservation${suffix}.php`,
  timeChange: `/backend/time_change${suffix}.php`,
});

/**
 * The three activities of the event. Each maps to its own backend table / endpoint set.
 * `keywords` are matched (lower-case, substring) against the activity name stored in QR codes –
 * the old Beetlejuice-era names are kept so previously issued QR codes still scan correctly.
 */
export const ACTIVITIES = [
  {
    key: "stezka",
    table: "reservations",
    tableNumber: 1,
    title: "Stezka Zemí vzpomínek s La Muerte",
    shortName: "Stezka Zemí vzpomínek",
    description:
      "Vhodné pro mladší s doprovodem (registrujte celkový počet účastníků, tj. děti včetně dospělých). Délka trasy: ~ 30 min (podle odvahy).",
    maxTeamSize: 8,
    isMain: true,
    buttonClass: "btn-marigold",
    cta: "Rezervovat Stezku",
    chips: [
      { label: "~ 30 min", tone: "agua" },
      { label: "max 8 v týmu", tone: "" },
    ],
    slotStepMinutes: 10,
    breakMinute: 50,
    api: backendApi(""),
    keywords: ["stezka", "vzpomínek", "la muerte", "záhrobím", "beetlejuice"],
  },
  {
    key: "ofrenda",
    table: "reservations_mira",
    tableNumber: 2,
    title: "Ofrenda, kde šepot nezmizel",
    shortName: "Ofrenda",
    description:
      "Oltář předků, kde hlasy zesnulých ještě neutichly. Vhodné pro starší. Délka aktivity: ~ 10 min.",
    maxTeamSize: 4,
    isMain: false,
    buttonClass: "btn-rosa",
    cta: "Rezervovat Ofrendu",
    chips: [
      { label: "~ 10 min", tone: "agua" },
      { label: "15+", tone: "rosa" },
    ],
    slotStepMinutes: 15,
    breakMinute: 45,
    api: backendApi("_mira"),
    keywords: ["ofrenda", "šepot", "dům"],
  },
  {
    key: "komnata",
    table: "reservations_third",
    tableNumber: 3,
    title: "Komnata zapomenutých",
    shortName: "Komnata zapomenutých",
    description:
      "Ti, na které nikdo nevzpomíná, mizí navždy. Vhodné pro všechny, jak starší, tak mladší. Délka aktivity: ~ 5 min.",
    maxTeamSize: 2,
    isMain: false,
    buttonClass: "btn-agua",
    cta: "Rezervovat Komnatu",
    chips: [
      { label: "~ 5 min", tone: "agua" },
      { label: "pro všechny", tone: "" },
    ],
    slotStepMinutes: 10,
    breakMinute: 50,
    api: backendApi("_third"),
    keywords: ["komnata", "zapomenutých", "prokletá"],
  },
].map((activity) => ({
  ...activity,
  slots: buildSlots(EVENT_START_MINUTES, EVENT_END_MINUTES, activity.slotStepMinutes, activity.breakMinute),
}));

export const MAIN_ACTIVITY = ACTIVITIES[0];

export const getActivityByTable = (table) => ACTIVITIES.find((activity) => activity.table === table);

export const getActivityByTableNumber = (tableNumber) =>
  ACTIVITIES.find((activity) => activity.tableNumber === Number(tableNumber));

export const getActivityName = (table) => getActivityByTable(table)?.title ?? "Neznámá aktivita";

const LEGACY_TABLE_IDS = { table1: 1, table2: 2, table3: 3 };
const DEFAULT_TABLE_NUMBER = 1;

/** Resolve which activity (table number) a scanned QR payload belongs to. Supports old and new formats. */
export const detectTableNumber = (data) => {
  if (data?.activity) {
    const name = String(data.activity).toLowerCase();
    const match = ACTIVITIES.find((activity) => activity.keywords.some((keyword) => name.includes(keyword)));
    if (match) return match.tableNumber;
  }
  if (data?.table) {
    const byTable = getActivityByTable(data.table);
    if (byTable) return byTable.tableNumber;
    if (LEGACY_TABLE_IDS[data.table]) return LEGACY_TABLE_IDS[data.table];
  }
  return DEFAULT_TABLE_NUMBER;
};
